/**
 * API Configuration for StockPro
 */

const environment = process.env.NODE_ENV || 'development';

const API_CONFIG = {
  development: {
    baseURL: '/api',
    timeout: 10000,
    withCredentials: false
  },
  production: {
    baseURL: '/api',
    timeout: 10000,
    withCredentials: false
  },
  test: {
    baseURL: '/api',
    timeout: 10000,
    withCredentials: false
  }
};

export default API_CONFIG[environment];